import styled from "styled-components";

// メインコンテナ
const AccountInfoContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  /* max-width: 800px; */
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  padding: 20px;
`;

// タイトル
const AccountInfoTitle = styled.h2`
  background: url(../images/window_title.png) no-repeat 0 50%;
  padding: 5px 0 0 35px;
  color: #333;
  font-size: 24px;
  line-height: 30px;
  margin-bottom: 15px;
`;

// セクションタイトル
const SectionTitle = styled.h3`
  padding: 5px 0 0 5px;
  color: #333;
  font-size: 20px;
  line-height: 30px;
  margin: 30px 0 10px;
  font-weight: bold;
  border-left: 5px solid #36f;
  &.accountinfo-container--kyoto-seibi {
    border-left: 5px solid #00b200;
  }
`;

// テーブルコンテナ
const InfoTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0 5px;
  font-size: 14px;
`;

// テーブルヘッダー
const InfoTableHeader = styled.th`
  text-align: left;
  color: #495057;
  vertical-align: middle;
  width: 13em;
  background: #bccdff;
  font-weight: bold;
  border: 1px solid #333;
  padding: 8px 2px;
  &.accountinfo-container--kyoto-seibi {
    background: #99ffa3;
  }
`;

// テーブルセル
const InfoTableCell = styled.td`
  vertical-align: top;
  background: #fff;
  border: 1px solid #333;
  padding: 8px 2px;
`;

// 入力フィールド
const InputField = styled.input`
  width: 250px;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  &:disabled {
    background-color: #e9ecef;
    opacity: 1;
  }
`;

// 必須マーク
const RequiredMark = styled.img`
  width: 12px;
  height: 12px;
  margin-left: 5px;
  vertical-align: middle;
`;

// パスワード説明テキスト
const PasswordNote = styled.span`
  color: #6c757d;
  font-size: 12px;
  margin-left: 10px;
`;

// 住所情報コンテナ
const AddressContainer = styled.div`
  line-height: 1.6;
`;

// 住所行
const AddressLine = styled.div`
  margin-bottom: 5px;
`;

// ボタンコンテナ
const ButtonContainer = styled.div`
  text-align: center;
  margin: 20px 0;
  padding: 0 20px;
`;

// 変更ボタン
const ChangeButton_Old = styled.button`
  background: #007bff;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;

  &:hover {
    background: #0056b3;
  }

  &:disabled {
    background: #6c757d;
    cursor: not-allowed;
  }
`;
// 変更ボタン
const ChangeButton = styled.button`
  background: #007bff url(/images/arrow_important.png) no-repeat 10px 50%;
  color: #fff;
  height: 33px;
  border-style: solid;
  border-width: 1px;
  border-color: #007bff #007bff #007bff #007bff;
  border-radius: 5px;
  text-align: center;
  line-height: 33px;
  font-size: 18px;
  font-weight: bold;
  padding: 0 10px 0 30px;
  &:hover {
    background: #0056b3;
  }
  &:disabled {
    background: #6c757d;
    cursor: not-allowed;
  }
  &.accountinfo-container--kyoto-seibi {
    background: #5fbf00 url(/images/arrow_important.png) no-repeat 10px 50%;
    border-color: #ecffe5 #089308 #089308 #ecffe5;
    color: #FFF;
    &:hover {
      filter: brightness(0.95);
    }
  }
`;

// エラーメッセージ
const ErrorMessage = styled.div`
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 12px 15px;
  margin: 10px 20px;
  font-size: 14px;
`;

// 成功メッセージ
const SuccessMessage = styled.div`
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  padding: 12px 15px;
  margin: 10px 20px;
  font-size: 14px;
`;

// ローディングオーバーレイ
const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

// ローディングスピナー
const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

// 閉じるボタン
const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.15s ease-in-out;

  &:hover {
    background: #f8f9fa;
  }

  img {
    width: 30px;
    height: 30px;
  }
`;

// レスポンシブコンテナ
const ResponsiveContainer = styled.div`
  @media (max-width: 768px) {
    ${AccountInfoContainer} {
      /* max-width: 95vw; */
      margin: 10px;
    }

    ${InputField} {
      width: 100%;
      max-width: 300px;
    }

    ${InfoTableHeader} {
      width: auto;
      min-width: 100px;
    }

    ${ButtonContainer} {
      padding: 0 10px;
    }
  }
`;

const AccountInfoDialogStyles = {
  AccountInfoContainer,
  AccountInfoTitle,
  SectionTitle,
  InfoTable,
  InfoTableHeader,
  InfoTableCell,
  InputField,
  RequiredMark,
  PasswordNote,
  AddressContainer,
  AddressLine,
  ButtonContainer,
  ChangeButton,
  ErrorMessage,
  SuccessMessage,
  LoadingOverlay,
  LoadingSpinner,
  CloseButton,
  ResponsiveContainer,
};

export default AccountInfoDialogStyles;
